/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { createSlice } from "@reduxjs/toolkit";
import {
  setRegionFilterIdsAction,
  setSelectedTaskTypeAction,
  setSelectedTaskStatusAction,
  resetTaskFiltersAction,
} from "./actions";
import { ITaskFilterState } from "../types";

const initialState: ITaskFilterState = {
  regionFilterIds: [],
  selectedTaskType: "",
  selectedTaskStatus: "",
};

const taskFilterSlice = createSlice({
  name: "taskfilter",
  initialState,
  reducers: {
    setRegionFilterIds: setRegionFilterIdsAction,
    setSelectedTaskType: setSelectedTaskTypeAction,
    setSelectedTaskStatus: setSelectedTaskStatusAction,
    resetTaskFilters: resetTaskFiltersAction,
  }
});

export const TaskFilterReducer = taskFilterSlice.reducer;
export const {
  setRegionFilterIds,
  setSelectedTaskType,
  setSelectedTaskStatus,
  resetTaskFilters,
} = taskFilterSlice.actions;
